module.exports = __webpack_public_path__ + "img/p1-pic.5a006d7f.jpg";